export default __webpack_public_path__ + "static/media/75.756b55e2.gif";